import { Notifications } from '@mui/icons-material';
import { Box, SvgIconOwnProps, Typography } from '@mui/material';
import { useNotifications } from '@oai-frontend-monorepo/api';
import { memo } from 'react';

type Params = SvgIconOwnProps;

const NavUnreadCount = ({ ...props }: Params) => {
  const { data } = useNotifications({
    limit: 10,
    page: 1,
    unread: true,
  });

  const count = data?.pages?.[0]?.data.unread || 0;

  return (
    <Box position="relative">
      <Notifications {...props} />

      <Typography
        position="absolute"
        top={-8}
        right={count > 9 ? -14 : -8}
        variant="h5"
        fontWeight={900}
        ml={1}
        bgcolor={'#fff'}
        borderRadius={8}
      >
        {count}
      </Typography>
    </Box>
  );
};

export default memo(NavUnreadCount);
